import { Phone, Siren } from "lucide-react";
import { SITE } from "@/lib/siteConfig";
import { trackConversion } from "@/lib/gtag";

export default function EmergencyBadge() {
  return (
    <a
      href={SITE.phoneHref}
      onClick={() => trackConversion("phone_click_emergency_badge")}
      data-testid="emergency-badge"
      className="hidden lg:flex fixed bottom-5 left-5 z-50 group items-center gap-3 bg-[#0A0A0A] hover:bg-red-600 text-white pl-3 pr-5 py-3 border-l-4 border-red-600 hover:border-white shadow-2xl transition-all hover:-translate-y-0.5"
    >
      <div className="relative flex items-center justify-center w-10 h-10 bg-red-600 group-hover:bg-white transition-colors">
        <Siren className="w-5 h-5 text-white group-hover:text-red-600 transition-colors" strokeWidth={2.5} />
        <span className="absolute inset-0 pulse-ring rounded-none" />
      </div>
      <div className="leading-tight">
        <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-red-400 group-hover:text-white transition-colors">
          Urgence · 24h/24
        </div>
        <div className="flex items-center gap-2 font-display font-black text-base tracking-tight">
          <Phone className="w-4 h-4" strokeWidth={2.5} />
          {SITE.phone}
        </div>
      </div>
    </a>
  );
}
